export enum PrincipalType {
    USER = 'USER',
    ENGINE = 'ENGINE',
    SERVICE = 'SERVICE',
    WORKER = 'WORKER',
    UNKNOWN = 'UNKNOWN',
    KIZEO_ADMIN = 'KIZEO_ADMIN',

    /**
     * @deprecated
     */
    SUPER_USER = 'SUPER_USER',
}

export const ALL_PRINCIPAL_TYPES = Object.values(PrincipalType)

export const SERVICE_KEY_SECURITY_OPENAPI = {
    apiKey: [],
}

export enum EndpointScope {
    PLATFORM = 'PLATFORM',
    PROJECT = 'PROJECT',
}

export enum EmbeddedApp {
    KIZEO = 'kizeo',
}